import React from "react";
import DashboardCard from "../DashboardCard";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useTranslation } from "react-i18next";
import Chart from "react-apexcharts";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { colors } from "components/Theme/WebTheme";
import { Select, MenuItem, FormControl, Box, Typography } from "@mui/material";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PaymentIcon from "@mui/icons-material/Payment";

const DashboardOldUI = ({
    // All props from Dashboard parent
    customerCount,
    driverCount,
    activeCount,
    powerTranzActive,
    auth,
    mylocation,
    locationStatus,
    locations,
    countries,
    selectedCountry,
    handleCountrySelect,
    dailygross,
    monthlygross,
    totalgross,
    data,
    barChartOptions,
    barChart,
}) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();

    return (
        <div>
            <Grid
                container
                direction="row"
                spacing={2}
                style={{ marginTop: 25 }}
            >
                <Grid
                    item
                    xs
                    style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                >
                    <Card
                        style={{
                            borderRadius: "19px",
                            boxShadow: 6,
                            backgroundColor: colors.MAIN_COLOR,
                            minHeight: 120,
                            padding: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <GroupsOutlinedIcon
                            style={{ color: "white", fontSize: 52 }}
                        />
                        <div>
                            <Typography
                                style={{
                                    color: colors.WHITE,
                                    textAlign: "center",
                                    fontSize: 26,
                                    fontWeight: "bold",
                                }}
                            >
                                {customerCount}
                            </Typography>
                            <Typography
                                style={{
                                    color: colors.WHITE,
                                    textAlign: "center",
                                    fontSize: 20,
                                }}
                            >
                                {t("total_cumtomer")}
                            </Typography>
                        </div>
                    </Card>
                </Grid>
                <Grid
                    item
                    xs
                    style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                >
                    <Card
                        style={{
                            borderRadius: "19px",
                            boxShadow: 6,
                            backgroundColor: colors.MAIN_COLOR + "D8",
                            minHeight: 120,
                            padding: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <GroupsOutlinedIcon
                            style={{ color: "white", fontSize: 52 }}
                        />
                        <div>
                            <Typography
                                style={{
                                    color: colors.WHITE,
                                    textAlign: "center",
                                    fontSize: 26,
                                    fontWeight: "bold",
                                }}
                            >
                                {driverCount}
                            </Typography>
                            <Typography
                                style={{
                                    color: colors.WHITE,
                                    textAlign: "center",
                                    fontSize: 20,
                                }}
                            >
                                {t("total_drivers")}
                            </Typography>
                        </div>
                    </Card>
                </Grid>
                <Grid
                    item
                    xs
                    style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                >
                    <Card
                        style={{
                            borderRadius: "19px",
                            boxShadow: 6,
                            backgroundColor: colors.MAIN_COLOR + "B2",
                            minHeight: 120,
                            padding: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <PeopleAltOutlinedIcon
                            style={{ color: "white", fontSize: 42 }}
                        />
                        <div>
                            <Typography
                                style={{
                                    color: colors.WHITE,
                                    textAlign: "center",
                                    fontSize: 26,
                                    fontWeight: "bold",
                                }}
                            >
                                {activeCount}
                            </Typography>
                            <Typography
                                style={{
                                    color: colors.WHITE,
                                    textAlign: "center",
                                    fontSize: 20,
                                }}
                            >
                                {t("active_driver")}
                            </Typography>
                        </div>
                    </Card>
                </Grid>
                {powerTranzActive && auth.profile.usertype === "admin" && (
                    <Grid
                        item
                        xs
                        style={{
                            textAlign: isRTL === "rtl" ? "right" : "left",
                        }}
                    >
                        <Card
                            style={{
                                borderRadius: "19px",
                                boxShadow: 6,
                                backgroundColor: colors.MAIN_COLOR + "80",
                                minHeight: 120,
                                padding: 28,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                cursor: "pointer",
                            }}
                            onClick={() =>
                                (window.location.href =
                                    "/powertranz-transactions")
                            }
                        >
                            <PaymentIcon
                                style={{ color: "white", fontSize: 42 }}
                            />
                            <div>
                                <Typography
                                    style={{
                                        color: colors.WHITE,
                                        textAlign: "center",
                                        fontSize: 26,
                                        fontWeight: "bold",
                                    }}
                                >
                                    PowerTranz
                                </Typography>
                                <Typography
                                    style={{
                                        color: colors.WHITE,
                                        textAlign: "center",
                                        fontSize: 20,
                                    }}
                                >
                                    Transactions
                                </Typography>
                            </div>
                        </Card>
                    </Grid>
                )}
            </Grid>
            <Grid item xs={12} style={{ marginTop: 20 }}>
                <Grid
                    container
                    style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                >
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={9}
                        lg={9}
                        style={{
                            backgroundColor: colors.SECONDARY,
                            borderRadius: 20,
                            overflow: "hidden",
                        }}
                        boxShadow={3}
                    >
                        <Typography
                            variant="h5"
                            style={{
                                color: colors.WHITE,
                                margin: "20px 20px 0 15px",
                                textAlign: isRTL === "rtl" ? "right" : "left",
                            }}
                        >
                            {t("real_time_driver_section_text")}
                            {locationStatus === "fallback" && (
                                <span
                                    style={{
                                        fontSize: "14px",
                                        opacity: 0.8,
                                        marginLeft: "10px",
                                    }}
                                >
                                    ({t("using_default_location")})
                                </span>
                            )}
                        </Typography>
                        {mylocation && mylocation.lat ? (
                            <GoogleMap
                                zoom={locationStatus === "fallback" ? 12 : 10}
                                center={mylocation}
                                mapContainerStyle={{ height: `528px` }}
                                onLoad={() =>
                                    console.log(
                                        "Dashboard: GoogleMap loaded successfully"
                                    )
                                }
                                onError={(error) =>
                                    console.error(
                                        "Dashboard: GoogleMap error:",
                                        error
                                    )
                                }
                            >
                                {locations && locations.length > 0
                                    ? locations.map((marker, index) => (
                                          <Marker
                                              position={{
                                                  lat: marker.lat,
                                                  lng: marker.lng,
                                              }}
                                              key={`driver-${marker.id}-${index}`}
                                              icon={{
                                                  url: marker.carImage,
                                                  scaledSize:
                                                      new window.google.maps.Size(
                                                          35,
                                                          25
                                                      ),
                                              }}
                                              title={marker.drivername}
                                              onClick={() => {
                                                  console.log(
                                                      "Dashboard: Marker clicked:",
                                                      marker.drivername
                                                  );
                                              }}
                                          />
                                      ))
                                    : null}
                            </GoogleMap>
                        ) : (
                            <div
                                style={{
                                    height: "528px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: colors.WHITE,
                                    fontSize: "16px",
                                    padding: "20px",
                                }}
                            >
                                <div style={{ marginBottom: "10px" }}>
                                    {locationStatus === "getting"
                                        ? t("getting_location") ||
                                          "Getting your location..."
                                        : t("loading_drivers") ||
                                          "Loading drivers..."}
                                </div>
                                {locationStatus === "getting" && (
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            opacity: 0.7,
                                            textAlign: "center",
                                        }}
                                    >
                                        {t("location_permission_info") ||
                                            "Please allow location access or we'll use default view"}
                                    </div>
                                )}
                            </div>
                        )}
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={3}
                        lg={3}
                        style={{ padding: 15 }}
                    >
                        <Typography
                            variant="h4"
                            style={{
                                textAlign: isRTL === "rtl" ? "right" : "left",
                            }}
                        >
                            {t("gross_earning")}
                        </Typography>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedCountry}
                                onChange={handleCountrySelect}
                                style={{
                                    textAlign:
                                        isRTL === "rtl" ? "right" : "left",
                                    border: "1px solid #9E9E9E",
                                }}
                            >
                                <MenuItem
                                    disabled
                                    value={t("select_country")}
                                    style={{
                                        direction:
                                            isRTL === "rtl" ? "rtl" : "ltr",
                                        width: "100%",
                                        justifyContent: "flex-start",
                                        paddingLeft: 10,
                                    }}
                                >
                                    {t("select_country")}
                                </MenuItem>
                                {countries && countries.length > 0
                                    ? countries.map((item) => (
                                          <MenuItem
                                              dense={true}
                                              key={item.country}
                                              value={item.country_code}
                                              style={{
                                                  direction:
                                                      isRTL === "rtl"
                                                          ? "rtl"
                                                          : "ltr",
                                                  width: "100%",
                                                  justifyContent: "flex-start",
                                                  paddingLeft: 10,
                                              }}
                                          >
                                              {t(item.country)}
                                          </MenuItem>
                                      ))
                                    : null}
                            </Select>
                        </FormControl>
                        <Grid
                            container
                            direction="row"
                            spacing={2}
                            style={{ padding: 15 }}
                        >
                            <Grid
                                item
                                xs
                                style={{
                                    textAlign:
                                        isRTL === "rtl" ? "right" : "left",
                                }}
                            >
                                {data && data.swipe_symbol === false ? (
                                    <DashboardCard
                                        crdStyle={{
                                            display: "flex",
                                            borderRadius: "19px",
                                            backgroundColor: colors.MAIN_COLOR,
                                            minHeight: 120,
                                        }}
                                        title={t("today_text")}
                                        image={
                                            require("../../assets/img/money1.jpg")
                                                .default
                                        }
                                    >
                                        {(data?.symbol || "") +
                                            " " +
                                            dailygross}
                                    </DashboardCard>
                                ) : (
                                    <DashboardCard
                                        crdStyle={{
                                            display: "flex",
                                            borderRadius: "19px",
                                            backgroundColor: colors.MAIN_COLOR,
                                        }}
                                        title={t("today_text")}
                                        image={
                                            require("../../assets/img/money1.jpg")
                                                .default
                                        }
                                    >
                                        {dailygross +
                                            " " +
                                            (data?.symbol || "")}
                                    </DashboardCard>
                                )}
                            </Grid>
                            <Grid
                                item
                                xs
                                style={{
                                    textAlign:
                                        isRTL === "rtl" ? "right" : "left",
                                }}
                            >
                                {data && data.swipe_symbol === false ? (
                                    <DashboardCard
                                        crdStyle={{
                                            display: "flex",
                                            borderRadius: "19px",
                                            backgroundColor:
                                                colors.MAIN_COLOR + "D8",
                                            minHeight: 120,
                                        }}
                                        title={t("this_month_text")}
                                        image={
                                            require("../../assets/img/money2.jpg")
                                                .default
                                        }
                                    >
                                        {(data?.symbol || "") +
                                            " " +
                                            monthlygross}
                                    </DashboardCard>
                                ) : (
                                    <DashboardCard
                                        crdStyle={{
                                            display: "flex",
                                            borderRadius: "19px",
                                            backgroundColor:
                                                colors.MAIN_COLOR + "D8",
                                        }}
                                        title={t("this_month_text")}
                                        image={
                                            require("../../assets/img/money2.jpg")
                                                .default
                                        }
                                    >
                                        {monthlygross +
                                            " " +
                                            (data?.symbol || "")}
                                    </DashboardCard>
                                )}
                            </Grid>
                            <Grid
                                item
                                xs
                                style={{
                                    textAlign:
                                        isRTL === "rtl" ? "right" : "left",
                                }}
                            >
                                {data && data.swipe_symbol === false ? (
                                    <DashboardCard
                                        crdStyle={{
                                            display: "flex",
                                            borderRadius: "19px",
                                            backgroundColor:
                                                colors.MAIN_COLOR + "B2",
                                            minHeight: 120,
                                        }}
                                        title={t("total")}
                                        image={
                                            require("../../assets/img/money3.jpg")
                                                .default
                                        }
                                    >
                                        {(data?.symbol || "") +
                                            " " +
                                            totalgross}
                                    </DashboardCard>
                                ) : (
                                    <DashboardCard
                                        crdStyle={{
                                            display: "flex",
                                            borderRadius: "19px",
                                            backgroundColor:
                                                colors.MAIN_COLOR + "B2",
                                        }}
                                        title={t("total")}
                                        image={
                                            require("../../assets/img/money3.jpg")
                                                .default
                                        }
                                    >
                                        {totalgross +
                                            " " +
                                            (data?.symbol || "")}
                                    </DashboardCard>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Box
                style={{
                    padding: 10,
                    marginTop: 30,
                    borderRadius: 20,
                    backgroundColor: colors.WHITE,
                }}
                boxShadow={6}
            >
                <Typography
                    style={{
                        margin: "5px 20px 0 15px",
                        color: colors.MAIN_COLOR,
                    }}
                    variant="h5"
                >
                    {t("booking_chart")}
                </Typography>
                <Chart
                    options={barChartOptions}
                    series={barChart}
                    type="area"
                    width="100%"
                    height={360}
                />
            </Box>
        </div>
    );
};

export default DashboardOldUI;
